import React, { PureComponent } from "react";
// import PropTypes from "prop-types";
import { findDOMNode } from "react-dom";
import moment from "moment";
import { isEmpty, isExist } from "cxa-utils";
import { CLOSE_MESSAGE } from "./constants";

const SPOUSE_KEYS = ["SpouseName", "SpouseIdentification"];
const CHILDREN_KEYS = [
  ["FirstChildName", "FirstChildIdentification"],
  ["SecondChildName", "SecondChildIdentification"],
  ["ThirdChildName", "ThirdChildIdentification"],
  ["FourthChildName", "FourthChildIdentification"],
  ["FifthChildName", "FifthChildIdentification"],
  ["SixthChildName", "SixthChildIdentification"],
  ["SeventhChildName", "SeventhChildIdentification"],
  ["EighthChildName", "EighthChildIdentification"],
  ["NinthChildName", "NinthChildIdentification"],
  ["TenthChildName", "TenthChildIdentification"],
];

/**
 * Query HTML elements
 * @param  {Element}  node
 * @return {Function}
 */
const elQuery = node => tagName => node.querySelectorAll(tagName);

/**
 * Every fild is empty?
 * @param  {Object}   byId
 * @return {Function}
 */
const shouldRemoveRow = byId => (keys = []) =>
  keys.every(key => {
    const field = byId[key] || {};

    if (isEmpty(field) || isEmpty(field.fieldValue)) {
      return true;
    }

    return false;
  });

/**
 * Find 'CompletedOn' field
 *
 * @NOTE when empty
 *  - 'find' will return undefined
 *  - 'filter' will return []
 * @param  {Object} byId
 * @return {Array}
 */
const findCompletedOnField = byId =>
  Object.values(byId).filter(({ fieldName }) => fieldName === "CompletedOn");

/**
 * HOC
 * @param  {Component} WrappedComponent
 * @return {Component}
 */
const enhance = WrappedComponent => {
  return class EnhanceHDF extends PureComponent {
    state = {
      isCompleted: false,
    };

    // eslint-disable-next-line
    componentWillReceiveProps(nextProps) {
      const { employeeParticulars } = nextProps;
      const { byId } = employeeParticulars;
      const { HDFormID = {} } = byId;

      // TODO:
      // - Refactoring this later that using component state
      if (HDFormID && HDFormID.fieldValue === "GEHDMOREDEP2018") {
        const DOMNode = findDOMNode(this); // eslint-disable-line
        const _shouldRemoveRow = shouldRemoveRow(byId);
        const shouldRemoveSpouseRow = _shouldRemoveRow(SPOUSE_KEYS);
        const spouseNameNode = DOMNode.querySelector("#RO_SpouseName");

        if (isExist(spouseNameNode) && shouldRemoveSpouseRow) {
          const parent = spouseNameNode.parentElement;
          if (parent.parentNode !== null) {
            parent.parentNode.removeChild(parent);
          }
        }

        CHILDREN_KEYS.forEach(childKeys => {
          const [nameKey] = childKeys;
          const shouldRemoveChildRow = _shouldRemoveRow(childKeys);
          const childNameNode = DOMNode.querySelector(`#RO_${nameKey}`);

          if (isExist(childNameNode) && shouldRemoveChildRow) {
            const parent = childNameNode.parentElement;
            if (parent.parentNode !== null) {
              parent.parentNode.removeChild(parent);
            }
          }
        });
      }

      if (isExist(byId)) {
        findCompletedOnField(byId).forEach(({ fieldValue }) =>
          this.setState({
            isCompleted: isExist(fieldValue),
          })
        );
      }
    }

    componentDidUpdate() {
      const { isCompleted } = this.state;

      if (isCompleted) {
        this.disableAllInputs(isCompleted);
      }
    }

    render() {
      const { isCompleted } = this.state;

      return (
        <WrappedComponent
          isReadOnly={isCompleted}
          renderValue={this.renderValue}
          onSave={this.handleSave}
          onPrint={this.handlePrint}
          onClose={this.handleClose}
          {...this.props}
        />
      );
    }

    /**
     * Disable all fields
     * @param {boolean} isCompleted
     */
    disableAllInputs = isCompleted => {
      // @NOTE Do not use 'findDOMNode'
      const DOMNode = findDOMNode(this); // eslint-disable-line
      const _getTags = elQuery(DOMNode);

      ["input", "select", "textarea"]
        .reduce((acc, tagName) => [...acc, ..._getTags(tagName)], [])
        .forEach(el => el.setAttribute("disabled", isCompleted));
    };

    /**
     * Common render function
     * @param  {Object} data
     * @param  {string} defaultValue
     * @return {string}
     */
    renderValue = (data, defaultValue) => {
      const { employeeParticulars } = this.props;
      const { byId } = employeeParticulars;

      if (isExist(byId)) {
        const { fieldName, fieldFormat, dateFormat } = data;

        if (fieldName in byId) {
          const { fieldValue } = byId[fieldName];

          if (fieldFormat === "date") {
            return isExist(fieldValue)
              ? moment(fieldValue).format(dateFormat ? dateFormat : "")
              : " ";
          }
          if (fieldFormat === "money") {
            if (isExist(fieldValue)) {
              let floatValue = parseFloat(fieldValue);

              // Round the float to two decimal places
              return floatValue.toFixed(2);
            } else {
              return "";
            }
          }

          return fieldValue;
        }
      }

      return defaultValue;
    };

    handleSave = id => evt => {
      evt.preventDefault();

      const { save } = this.props;

      save(id);
    };

    handlePrint = evt => {
      evt.preventDefault();

      window.print();
    };

    handleClose = evt => {
      evt.preventDefault();

      const { isCompleted } = this.state;
      let bool = true;

      // isCompleted === read only === no deen alert
      if (!isCompleted) {
        bool = confirm(CLOSE_MESSAGE);
      }

      if (bool) {
        window.close();
      }
    };
  };
};

export default enhance;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/hoc.js